export const CHECKOUT_URL =
  'https://prosthodontics-visual-atlas.impultienda.ar/checkout'

export const BOX_IMAGE =
  'https://cdn.magicpatterns.com/uploads/sGa5P3RrwSXfWga2EPSRJ3/Diseno-sin-titulo-2-2.webp'

export const previewImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/hPo7i1T2NPS2Dp8baJGGPB/Captura_de_pantalla_2026-09-02_a_la(s)_6.07.15_p._m..png',
    alt: 'Visual map: Border Molding — Recording Dynamic Border Positions',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/kZws54wa2iJNwC38gG4wzX/Captura_de_pantalla_2026-09-02_a_la(s)_6.06.10_p._m..png',
    alt: 'Visual map: Artificial Tooth Selection — Factors and Educational Considerations',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/2guPwS1S6TQoadQsMq553Z/Captura_de_pantalla_2026-09-02_a_la(s)_6.05.39_p._m..png',
    alt: 'Visual map: Maxillary Borders, Limiting Structures and Relief',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/n5igk3ZHBBgadkoS9CPH8q/Captura_de_pantalla_2026-09-02_a_la(s)_6.05.19_p._m..png',
    alt: 'Visual map: Maxillary Edentulous Arch — Major Anatomical Landmarks',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/64xeWhAZdrsfCZRXe7A2gA/Captura_de_pantalla_2026-09-02_a_la(s)_6.06.34_p._m..png',
    alt: 'Study resource: Workflow Organization — Testing Your Understanding',
  },
]

export const systemFeatures = [
  'Clear visual study maps',
  'Labeled prosthodontic components',
  'Organized classifications',
  'Side-by-side comparisons',
  'Clinical workflow overviews',
  'Materials and component references',
  'Structured revision resources',
]

export const modules = [
  {
    num: 1,
    title: 'COMPLETE DENTURES VISUAL ATLAS™',
    body: 'Understand complete dentures through organized visual maps covering oral anatomy and landmarks, denture components, impressions, custom trays, border molding, jaw relations, occlusal concepts, tooth selection and arrangement, clinical and laboratory workflow, and common errors and complications.',
    kicker: 'See the system. Connect the concepts. Review clearly.',
  },
  {
    num: 2,
    title: 'REMOVABLE PARTIAL DENTURES VISUAL ATLAS™',
    body: 'Study Kennedy Classification, RPD components, major and minor connectors, direct and indirect retention, rests and rest seats, surveying concepts, design principles and the broad clinical sequence through clear visual references.',
    kicker: 'Identify the component. Understand its role.',
  },
  {
    num: 3,
    title: 'FIXED PROSTHODONTICS VISUAL ATLAS™',
    body: 'Review crowns, bridges, pontic designs, finish lines, tooth preparation principles, provisional restorations, impressions, cementation, material selection and clinical workflows in one organized visual module.',
    kicker: 'Compare the concepts. Understand the workflow.',
  },
  {
    num: 4,
    title: 'IMPLANT PROSTHODONTICS VISUAL ATLAS™',
    body: 'Understand implant components, implant–abutment–restoration relationships, abutment concepts, impression techniques, digital workflows, screw-retained versus cement-retained concepts, single-unit restorations, implant-supported prostheses and overdenture concepts.',
    kicker: 'See each component. Understand how they connect.',
  },
  {
    num: 5,
    title: 'OCCLUSION & IMPRESSIONS VISUAL ATLAS™',
    body: 'Review essential occlusal terminology, centric relation, maximum intercuspation, mandibular movements, articulators, occlusal schemes, impression materials, impression techniques, tray concepts and common impression errors.',
    kicker: 'Distinguish similar concepts more clearly.',
  },
  {
    num: 6,
    title: 'MATERIALS, COMPONENTS & CLINICAL WORKFLOWS™',
    body: 'Access organized visual references for ceramics, zirconia, metals, acrylic resins, resin-based materials, luting materials, prosthodontic components, clinical and laboratory stages, workflow maps and common points of confusion.',
    kicker: 'Connect materials, components and workflows.',
  },
]

export const bonuses = [
  {
    num: 1,
    title: 'PROSTHODONTICS ACTIVE RECALL CARDS™',
    body: 'Use focused visual recall cards to review terminology, classifications, components, comparisons and important relationships across all six areas. Identify what you know, what needs review and what you need to relearn.',
    kicker: 'Recall it. Check it. Strengthen it.',
  },
  {
    num: 2,
    title: 'PROSTHODONTICS EXAM REVIEW™',
    body: 'Organize your revision with high-yield visual maps, concept checks, classification reviews, component recognition, common-confusion sections and mixed review questions.',
    kicker: 'Review smarter. Find your weak areas.',
  },
  {
    num: 3,
    title: 'PROSTHODONTIC COMPONENT IDENTIFICATION GUIDE™',
    body: 'Quickly recognize and understand important components from Complete Dentures, RPDs, Fixed Prosthodontics, Implant Prosthodontics, Impressions and Materials. See the component, learn its name and understand its general role.',
    kicker: 'See it. Name it. Understand it.',
  },
  {
    num: 4,
    title: 'PROSTHODONTICS COMPARISON ATLAS™',
    body: 'Compare concepts that are easy to confuse through clear side-by-side visual references. Understand what they share, how they differ and how to recognize the distinction.',
    kicker: 'Compare. Distinguish. Understand.',
  },
  {
    num: 5,
    title: '30-DAY PROSTHODONTICS STUDY SYSTEM™',
    body: 'Follow a structured 30-day revision pathway through Complete Dentures, RPDs, Fixed Prosthodontics, Implants, Occlusion, Impressions, Materials and integrated review.',
    kicker: 'Know what to study next.',
  },
]

export const differentiators = [
  {
    emoji: '🦷',
    title: 'Visual Study Maps',
    body: 'Turn complex topics into organized visual references.',
  },
  {
    emoji: '🔎',
    title: 'Clear Component Identification',
    body: 'Recognize important prosthodontic components more easily.',
  },
  {
    emoji: '↔️',
    title: 'Side-by-Side Comparisons',
    body: 'Separate concepts that are easy to confuse.',
  },
  {
    emoji: '🧩',
    title: 'Connected Workflows',
    body: 'Understand how important stages relate to each other.',
  },
  {
    emoji: '📋',
    title: 'Structured Revision Tools',
    body: 'Review concepts and identify weak areas more efficiently.',
  },
  {
    emoji: '⏱️',
    title: 'Less Searching',
    body: 'Keep your Prosthodontics study resources together in one organized system.',
  },
]

export const offerIncludes = [
  '6 Professional Modules',
  '5 Premium Bonuses',
  'Visual Study Maps',
  'Component Identification',
  'Classification References',
  'Side-by-Side Comparisons',
  'Clinical Workflow Overviews',
  'Structured Revision Tools',
]

export const testimonials = [
  {
    text: 'I used to spend entire evenings jumping between three textbooks and my lecture slides just to understand one denture stage. With the Visual Atlas I open one module, see the whole map, and the connections finally make sense. My Prosthodontics mark went from a borderline pass to a solid distinction in one semester.',
    author: 'Emily Harrington',
    role: '4th-year Dental Student, 23',
    location: 'Manchester, United Kingdom',
  },
  {
    text: 'RPD components were my nightmare — major connectors, minor connectors, rests, indirect retention, it all blurred together. The labeled component pages and the Comparison Atlas made me able to identify every part on sight. I walked into my viva and named everything without hesitating.',
    author: 'Daniel Whitfield',
    role: '3rd-year Dental Student, 22',
    location: 'Toronto, Canada',
  },
  {
    text: 'What sold me was the workflow overviews. I could never keep clinical and lab stages in the right order for complete dentures. Seeing the entire sequence laid out visually fixed that in a single afternoon. I now use the 30-Day Study System to structure every revision block.',
    author: 'Sophia Ramirez',
    role: '5th-year Dental Student, 25',
    location: 'Chicago, United States',
  },
  {
    text: 'Occlusion terminology used to feel impossible — centric relation versus maximum intercuspation, articulators, occlusal schemes. The side-by-side comparisons separated all of it clearly. For the first time I studied Prosthodontics without feeling like I was drowning in definitions.',
    author: 'Olivia Bennett',
    role: '4th-year Dental Student, 24',
    location: 'Melbourne, Australia',
  },
  {
    text: 'I bought it two weeks before my finals expecting just another PDF. Instead I got an organized system: implant components, materials, classifications, everything in one place. The Active Recall Cards showed me exactly which areas were weak. Genuinely the most useful study resource I have purchased in dental school.',
    author: 'James Callahan',
    role: '5th-year Dental Student, 26',
    location: 'Leeds, United Kingdom',
  },
]

export const faqs = [
  {
    q: 'Is this a physical product?',
    a: 'No. PROSTHODONTICS VISUAL ATLAS™ is a 100% digital educational study resource.',
  },
  {
    q: 'Who is this for?',
    a: 'Dental students who want a clearer, more organized and visual way to study and review Prosthodontics.',
  },
  {
    q: 'Is this a dental certification program?',
    a: 'No. It is a study and revision resource, not a certification or clinical training program.',
  },
  {
    q: 'Is this just another Prosthodontics textbook?',
    a: 'No. It organizes key concepts through visual maps, classifications, labeled components, comparisons, workflow overviews and structured revision resources.',
  },
  {
    q: 'Do I need to organize the material myself?',
    a: 'No. The system is already divided into six organized visual modules and five complementary study resources.',
  },
  {
    q: 'Can I use it alongside my university material?',
    a: 'Yes. It is designed as a complementary study and revision resource alongside your formal dental education.',
  },
  {
    q: 'Does it cover Implant Prosthodontics?',
    a: 'Yes. A complete module is dedicated to implant prosthodontic concepts, components and workflows.',
  },
  {
    q: 'Does it include revision resources?',
    a: 'Yes. Active recall cards, exam review resources, component identification, comparison tools and a structured 30-day study system are included.',
  },
  {
    q: "Is it tied to one country's dental curriculum?",
    a: 'No. It is designed as an international English-language educational resource using established Prosthodontic concepts and terminology.',
  },
  {
    q: 'How will I receive it?',
    a: "You'll receive immediate digital access after purchase.",
  },
]

export const recentBuyers = [
  { name: 'Emily H.', location: 'Manchester, United Kingdom' },
  { name: 'Daniel W.', location: 'Toronto, Canada' },
  { name: 'Sophia R.', location: 'Chicago, United States' },
  { name: 'Olivia B.', location: 'Melbourne, Australia' },
  { name: 'James C.', location: 'Leeds, United Kingdom' },
  { name: 'Ava M.', location: 'Vancouver, Canada' },
  { name: 'Ethan P.', location: 'Sydney, Australia' },
  { name: 'Grace L.', location: 'Boston, United States' },
  { name: 'Liam O.', location: 'Birmingham, United Kingdom' },
  { name: 'Chloe T.', location: 'Brisbane, Australia' },
  { name: 'Noah F.', location: 'Calgary, Canada' },
  { name: 'Mia S.', location: 'Austin, United States' },
]
